import React from 'react';

import { Icon, Pressable } from '@rbilabs/universal-components';

import { CloseButtonWrapper } from './styled';

interface IProductDetailClose {
  onDismiss: () => void;
}

export const ProductDetailClose: React.FC<IProductDetailClose> = ({ onDismiss }) => {
  return (
    <CloseButtonWrapper>
      <Pressable onPress={onDismiss}>
        <Icon variant="cancel" />
      </Pressable>
    </CloseButtonWrapper>
  );
};
